import {actions} from 'src/app/modules/auth/redux/actions'

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = '*/*'
  // Auth rides on the API's HttpOnly auth_token cookie (VAPT TRT-12). The API only
  // honours that cookie on XHR requests, so every call must send X-Requested-With.
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  axios.defaults.withCredentials = true

  // Cookie expired or revoked (e.g. signed in elsewhere): drop the client session too.
  axios.interceptors.response.use(
    (response: any) => response,
    (err: any) => {
      if (err?.response?.status === 401 && store.getState().auth?.isLoggedIn) {
        store.dispatch(actions.logout())
      }
      return Promise.reject(err)
    }
  )
}
